import React from "react";

const TournamentTabBar = ({ tournaments, selectedId, onSelect }) => {
  if (tournaments.length <= 1) return null;

  return (
    <div className="flex overflow-x-auto no-scrollbar bg-slate-900 shadow-lg">
      {tournaments.map((t) => (
        <button
          key={t.id}
          onClick={() => onSelect(t.id)}
          className={`
            flex-shrink-0 px-4 py-3 text-sm font-medium transition-colors whitespace-nowrap
            ${
              selectedId === t.id
                ? "text-amber-400 border-b-2 border-amber-400"
                : "text-slate-400 hover:text-slate-200"
            }
          `}
        >
          {t.type}{" "}
          {new Date(t.date).toLocaleDateString("fr-FR", {
            day: "numeric",
            month: "short",
          })}
        </button>
      ))}
    </div>
  );
};

export default TournamentTabBar;
